module.exports = __webpack_public_path__ + "static/media/sport-team.f1841151.svg";